const maintenancesOutput = {
  title_scheduled: `Mantenimientos a Realizar`,
  title_pending: `Mantenimientos pendientes`,
  title_progress: `Mantenimientos en progreso`,
  title_expired: `Mantenimientos Retrasado`,
  title_completed: `Mantenimientos Concluidos`,
  title_overdue: `Mantenimientos Vencidos`,
  title: 'Mantenimientos',
};

export default maintenancesOutput;
